import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import { TableCellCustom } from '@app/components/table';
import { StatusTag } from '@app/components';
import { ILeaveManagement } from '../type';
import { LeaveManagementStatus } from '@app/constants';
import { RowActions } from './row-actions';
import { selectMyProfile } from '@app/modules/my-profile';
import { useAuthRolePermissions } from '@app/utils';

interface Props {
  row: ILeaveManagement;
  selected: boolean;
  onSelectRow: VoidFunction;
}
const LeaveManagementRow = (props: Props) => {
  const { row } = props;
  const authInfo = useSelector(selectMyProfile);
  const { hasPermission } = useAuthRolePermissions();
  const canEditLeaveSetting = hasPermission('LeaveSetting', 'w');

  if (!(authInfo?.role?.id === 1) && !row.status) {
    return null;
  }
  return (
    <>
      <TableCellCustom flex align="center">
        <Typography variant="body2">{row.id}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center" width={300}>
        <Typography variant="body2">{row.leaveType}</Typography>
      </TableCellCustom>
      <TableCellCustom align="center">
        <Typography variant="body2">{row.allowedDays}</Typography>
      </TableCellCustom>
      {canEditLeaveSetting ? (
        <>
          <TableCellCustom width={400} align="center">
            <StatusTag status={LeaveManagementStatus[row.status ? 1 : 0]} />
          </TableCellCustom>
          <TableCellCustom align="right" width={50}>
            <RowActions row={row} />
          </TableCellCustom>
        </>
      ) : null}
    </>
  );
};
export { LeaveManagementRow };
